module.exports = __webpack_public_path__ + "media/images/black-drivu-logo-e9c115110109daffb06a11075511264d.png";